<header class="head">
	<ng-template #content let-modal>
		<!-- <div class="modal-dialog"> -->
				<!-- <div class="modal-header">
					<h4>Sign In</h4>
				</div> -->
				<div class="modal-body">
					<h4>Sign In</h4>
					<hr>
	
					<ng-container *ngIf="clients.indexOf(curClient)==-1" >
						<span style="font-weight:600">Username</span>
						<input type="text" #username id="username" class="form-control mb-3 mt-3">
						<span style="font-weight:600">Password</span> 
						<a style="float:right; font-size:1rem; color:black; cursor:pointer" class="link-dark" (click)="modalReference.close(); open3(forgot)"> Forgot Password?</a>
						<input type="password" #password id="password" class="form-control mb-3 mt-3" >
						<button (click)="onLogin()" style="width:100%; background-color: rgb(195,212,47)" class="btn btn-default">Login</button>
						<hr>
						<div style="justify-content: center; text-align:center">

							<!-- <button   style="width:100%; "class="btn btn-default btn-outline-dark m-1">Register New User</button> -->
							<!-- <br> -->
							
							<button  style="width:100%; "(click)="modalReference.close(); open(inv)" class="btn btn-default btn-outline-dark m-1">Have Invitation Code?</button>
						</div>
					</ng-container>
					<!--<button  style="width:100%;"(click)="onAuth0Login()" class="btn btn-outline-eris mt-2">Login with Auth0</button>-->
					<button *ngIf="clients.indexOf(curClient)>-1" style="width:100%;" class="btn btn-outline-eris1 mt-2 mb-4" (click)="generalAzureLogin()">Login with Azure SSO</button>
					<!--<button *ngIf="curClient==clients[0]" style="width:100%;"(click)="onAzureLogin()" class="btn btn-outline-eris1 mt-2">Login with Azure SSO</button>
					<button *ngIf="curClient==clients[1]" style="width:100%;"(click)="onRinconAzureLogin()" class="btn btn-outline-eris2 mt-2">Login with Azure SSO</button>
					<button *ngIf="curClient==clients[2]" style="width:100%;"(click)="onRinconAzureLogin()" class="btn btn-outline-eris3 mt-2">Login with Azure SSO</button>-->
					
					
				</div>
		<!-- </div> -->
	</ng-template>
	<ng-template #forgot let-modal>
		<!-- <div class="modal-dialog"> -->
				<!-- <div class="modal-header">
					<h4>Sign In</h4>
				</div> -->
				<div class="modal-body">
					<h4>Forgot Password</h4>
					<hr>
					<span style="font-weight:600">Email</span>
					<input type="email" #forgotEmail id="forgotEmail" class="form-control mb-3 mt-3">
					<button (click)="modalReference4.close(); openLogin();" style="float:left" class="btn btn-default btn-outline-dark">Go Back</button>
					<button (click)="forgotPassword()" style="float:right; background-color: rgb(195,212,47)" class="btn btn-default">Send Email</button>
				</div>
		<!-- </div> -->
	</ng-template>
	<ng-template #inv let-modal>
		<!-- <div class="modal-dialog"> -->
				<!-- <div class="modal-header">
					<h4>Sign In</h4>
				</div> -->
				<div class="modal-body">
					<h4>Redeem Code</h4>
					<hr>
	
					<span style="font-weight:600">Email</span>
					<input type="text" #email id="email" class="form-control mb-3 mt-3">
					<span style="font-weight:600">Invitation Code</span> 
					<input type="code" #code id="code" class="form-control mb-3 mt-3" >
					<button (click)="modalReference2.close(); openLogin();" style="float:left" class="btn btn-default btn-outline-dark">Go Back</button>
					<button (click)="verify()" style="float:right; background-color: rgb(195,212,47)" class="btn btn-default">Continue</button>
				</div>
		<!-- </div> -->
	</ng-template>
	<ng-template #mfa let-modal>
		<!-- <div class="modal-dialog"> -->
				<!-- <div class="modal-header">
					<h4>Sign In</h4>
				</div> -->
				<div class="modal-body">
					<h4>MFA Verification</h4>
					<hr>	
					<span style="font-weight:600">MFA Code</span> 
					<input type="code" #mfacode id="mfacode" class="form-control mb-3 mt-3" >
					<!--<button (click)="modalReference5.close(); openLogin();" style="float:left" class="btn btn-default btn-outline-dark">Go Back</button>-->
					<button (click)="reSendCode()" style="float:left" class="btn btn-default btn-outline-dark">Re-send code</button>
					<button (click)="mfaverify()" style="float:right; background-color: rgb(195,212,47)" class="btn btn-default">OK</button>
				</div>
		<!-- </div> -->
	</ng-template>
	<ng-template #userinfo let-modal>
		<!-- <div class="modal-dialog"> -->
				<!-- <div class="modal-header">
					<h4>Sign In</h4>
				</div> -->
				<div class="modal-body">

					<h4>User Registration</h4>
					<hr>
					<div *ngIf="userData">
	 <form [formGroup]="registrationForm">
					<span style="font-weight:600">First Name</span>
					<input type="text" #firstname id="firstname" class="form-control mb-3 mt-3" [(ngModel)]="userData.FIRST_NAME"  [ngModelOptions]="{standalone: true}">
					<span style="font-weight:600">Last Name</span> 
					<input type="text" #lastname id="lastname" class="form-control mb-3 mt-3"  [(ngModel)]="userData.LAST_NAME"  [ngModelOptions]="{standalone: true}">
					<span style="font-weight:600">Alternate Email</span> 
					<input type="text" #altemail id="altemail" class="form-control mb-3 mt-3"  [(ngModel)]="userData.ALTERNATIVE_EMAIL"  [ngModelOptions]="{standalone: true}">
					<span style="font-weight:600">Phone (Numbers Only)<span style="color:red" *ngIf="!registrationForm.controls.userPhone.pristine && !registrationForm.controls.userPhone.valid "> *</span></span>
					<input style="max-width:none !important" mask="(000) 000-0000"  placeholder="Numbers Only" [class.invalid]="!registrationForm.controls.userPhone.pristine && !registrationForm.controls.userPhone.valid"
					  formControlName="userPhone" id="defaultForm-pass" class="form-control mb-3 mt-3">
					<span style="font-weight:600">Job Title</span> 
					<input type="text" #jobtitle id="jobtitle" class="form-control mb-3 mt-3"  [(ngModel)]="userData.JOB_TITLE"  [ngModelOptions]="{standalone: true}">
					<span *ngIf="userData.EXTERNAL_USER=='Y'" style="font-weight:600">Company Name <span style="color: red"> * </span></span> 
					<input *ngIf="userData.EXTERNAL_USER=='Y'" type="text" #companyName id="companyName" class="form-control mb-3 mt-3"  [(ngModel)]="userData.COMPANY_NAME"  [ngModelOptions]="{standalone: true}">
					<!--<ng-container *ngIf="userData.USER_SSO_IND=='Y'">
						<span style="font-weight:600">Single Sign On ID:<span style="color:red" *ngIf="!registrationForm.controls.singleID.pristine && !registrationForm.controls.singleID.valid || !registrationForm.value.singleID"> *</span></span>
						<input type="text" [class.invalid]="!registrationForm.controls.singleID.pristine && !registrationForm.controls.singleID.valid|| !registrationForm.value.singleID"
						formControlName="singleID" class="form-control mb-3 mt-3">
					</ng-container>-->
					<ng-container *ngIf="userData.USER_SSO_IND=='N'">
					<span style="font-weight:600">Password <span style="color:red" *ngIf="!registrationForm.controls.password.pristine && !registrationForm.controls.password.valid || !registrationForm.value.password"> *</span></span> 
					<input type="password" #newpassword id="newpassword" [class.invalid]="!registrationForm.controls.password.pristine && !registrationForm.controls.password.valid"  formControlName="password" id="defaultForm-pass" class="form-control mb-3 mt-3">
					<span style="font-weight:600">Confirm Password <span style="color:red" *ngIf="!registrationForm.controls.confirmpassword.pristine && !registrationForm.controls.confirmpassword.valid || !registrationForm.value.confirmpassword"> *</span></span> 
					<input [class.newmargin]= "registrationForm.value.password!= registrationForm.value.confirmpassword" type="password" #newpassword id="newpassword" [class.invalid]="!registrationForm.controls.confirmpassword.pristine && !registrationForm.controls.confirmpassword.valid"  formControlName="confirmpassword" id="defaultForm-pass" class="form-control mb-3 mt-3"
					>
					<span *ngIf = "passwordCheck">
						<ul>
							<li style='margin-bottom:5px' *ngIf="registrationForm.value.password!= registrationForm.value.confirmpassword" style="color:red">
								Passwords are not the same
							</li>
							<li style='margin-bottom:5px' *ngIf="registrationForm.controls.password.errors!==null && registrationForm.controls.password.errors.pattern!==undefined" style="color:red">
								Password must be at least 8 characters in length, and contain at least 1 uppercase character, 1 lowercase character, 1 symbol, and 1 number.
							</li>
						</ul>
					</span>
					</ng-container>
					<div *ngIf = "setCredsWarn">
						<span style='margin-bottom:5px'  style="color:red">
						{{setCredsWarnMessage}}
						</span>
					</div>
					<!--div *ngIf = "noPassWordError">
						<span style='margin-bottom:5px'  style="color:red">
						Please enter a Password
						</span>
					</div-->

					<div>
					</div>
					<br>
					<button (click)="modalReference3.close(); clearForms(); openLogin();" style="float:left" class="btn btn-default btn-outline-dark" id="btn-registercancel">Go Back</button>
					<button (click)="setCreds(); passwordCheck=true" style="background-color: rgb(195,212,47); float:right" class="btn btn-default" id="btn-registerconfirm">Register User</button>

					</form>
				</div>
			</div>
		<!-- </div> -->
	</ng-template>
	<ng-template #disclaimer let-modal>
		<div class="modal-header" style="background-color: #323232; color: rgb(222, 222, 222); border: 0px">
			<h4>Terms of Use</h4>
		</div>
		<div class="modal-body" style="background-color: rgb(28 36 51); color: rgb(222, 222, 222); padding:0px">
			<div style=" border: 4px solid rgb(9 17 33); padding:16px">
                <p>
                    Welcome to <b>Scriva by ERIS</b>, a web application (the “<b><u>Application</u></b>”) accessible at <span><a href="https://www.erisinfo.com" style="color:rgb(195,212,47)">app.scriva.com</a></span> (the “<b><u>Site</u></b>”) for the purpose of enabling a subscribed user and, if applicable, an employee of such user (“<b><u>Customer</u></b>”) to create collaborative documents and other work product (a “<b><u>Report</u></b>”) using data from a database linked to the Application (the “<b><u>Database</u></b>”), and data supplied by Customer.  The Application is made available in the United States by ERIS Information Inc., a Washington corporation, or in Canada by ERIS Information L.P., an Ontario partnership, (collectively, “<b><u>ERIS</u></b>”).  If you are not a Customer, you must immediately discontinue use of, and exit, the Application.  All use of the Application by Customer is subject to the following additional terms and conditions:
                </p>
                <p>
                    1. &nbsp;<u><b>Scope</b></u>
                    <br>
                    These Terms of Use govern all access to, and use of, the Application, the Database and any Report.   In using the Application, Customer agrees to these Terms of Use, and if an individual accesses the Application in his or her capacity as an employee, he or she also agrees to these Terms of Use on behalf of such individual’s employer. 
                </p>
                <p>
                    2. &nbsp;<u><b>Access</b></u>
                    <br>
                    The Application will generally be made available by ERIS for use by Customer.  However, ERIS may at any time, in its sole discretion, modify, or remove from the Internet, the Application without notice, and without any liability, to Customer for such removal or modification.  In addition, any access to, or attempt to access, equipment, software or information of ERIS or any third party not generally available to a Customer in connection with such Customer’s authorized use of the Application is prohibited.  If (a) an individual uses the Application on behalf of an employer and (b) the employment of such individual is terminated for any reason, the employer must immediately notify ERIS in writing of such termination, and the right of such individual to access the Application shall immediately terminate. 
                </p>
                <p>
                    3. &nbsp;<u><b>Permitted Use</b></u>
                    <br>
                    Customer may access and use the Application only to access or generate a Report or for other purposes expressly permitted by these Terms of Use or in a writing signed by ERIS.  All other access to, and use of, the Application by Customer is prohibited.  Without limiting the generality of the preceding sentence, Customer may not use the Application to (a) defame or harass ERIS or any third party, (b) distribute or promote any objectionable content (as determined by ERIS, in its sole discretion), (c) infringe any intellectual property rights of ERIS or a third party, (d) engage in any fraudulent or illegal conduct, (e) send spam, or malware, viruses or other harmful code, over the Internet, or (f) engage in any other conduct prohibited by (i) ERIS after notice of such prohibition is given to Customer or (ii) applicable law.  ERIS may, in its sole discretion, terminate Customer’s use of the Application at any time, whether with or without cause or notice. 
                </p>
                <p>
                    4. &nbsp;<u><b>Reports</b></u>
                    <br>
                    Each Report will be generated by Customer’s selecting, in Customer’s sole discretion, data from the Database and data supplied by Customer.  Subject to Section 3 of these Terms of Use, a Report may be used by Customer only for Customer’s legitimate business purposes.  Customer may not (a) amend, revise or modify, or grant access, distribute or otherwise transfer to any third party, a Report and (b) copy, print or publish a Report, except as necessary for such purposes.  The Database contains data from the public domain and other sources (including, but not limited to, federal, state, provincial and local governmental authorities), and ERIS is not responsible or liable for the accuracy or completeness of the Database.  ERIS is also not responsible or liable for the accuracy or completeness of any data supplied by Customer in generating a Report.  
                </p>
                <p>
                    5. &nbsp;<u><b>Additional Provisions</b></u>
                    <br>
                    There may be additional terms and conditions contained elsewhere on the Site (or affiliated websites offered by ERIS) that relate to Customer’s use of the Application or other functionality availability through the Site.  When applicable, use of the Application or such other functionality is subject to such additional terms and conditions.  For example, if any Report contains a report generated using  a product of ERIS (other than the Application), Customer must comply with all terms and conditions relating to such report (including, but not limited to, any requirement that the entirety of such report be contained in such Report).  In the event of a conflict or inconsistency between these Terms of Use and such additional terms and conditions, the former will control.   
                </p>
                <p>
                    6. &nbsp;<u><b>Application Credentials</b></u>
                    <br>
                    In order to access the Application, Customer will need to adopt and use a user name and password that comply with whatever protocol is from time to time established by ERIS for the Application.  Customer (a) is responsible for maintaining the confidentiality of Customer’s user name and password, and (b) must immediately notify ERIS in writing of any unauthorized access to, or use of, Customer’s user name or password.  ERIS will not have any responsibility or liability to Customer or any third party for Customer’s failure to keep confidential a user name or password, and ERIS may at any time, in its sole discretion, disable Customer’s user name or password for any reason without notice or liability to Customer for doing so.  In addition, ERIS may rely on any use of a user name and password, whether by Customer or a third party, as having been authorized by Customer, unless Customer has previously notified ERIS in writing of any unauthorized access to, or use of, the user name and password, and ERIS has had a reasonable opportunity of not less than 30 days to act on such notice. 
                </p>
                <p>
                    7. &nbsp;<u><b>Content</b></u>
                    <br>
                    All right, title and interest (including, but not limited to, all copyrights, service marks, trademark, trade secrets and other intellectual property rights) in the Application, and any content contained in the Database (collectively, “<b><u>Content</u></b>”), belongs to, or is licensed by, ERIS or is in the public domain.  ERIS grants to Customer a license to access and use any Content only (a) to generate and use a Report as expressly stated herein or (b) as otherwise authorized in writing by ERIS.  ERIS may at any time, in its sole discretion, modify any Content in, or remove any Content from, the Database or otherwise restrict its availability through the Application without notice or liability to Customer for such removal or modification.  Except as expressly set forth in these Terms of Use, no Customer is granted under any theory a license or other right to use any Content (including, but not limited to, any copyright, service mark, trademark, trade secret or other intellectual property right of ERIS), unless such Content is in the public domain. 
                </p>
                <p>
                    8. &nbsp;<u><b>Disclaimer</b></u>
                    <br>
                    <b>THE APPLICATION, THE DATABASE, ALL CONTENT, EACH REPORT AND THE SITE (“COMPONENT”) ARE MADE AVAILABLE “AS IS” AND WITHOUT ANY WARRANTY OR REPRESENTATION, WHETHER EXPRESS OR IMPLIED, OF ANY KIND (INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE).  WITHOUT LIMITING THE GENERALITY OF THE IMMEDIATELY PRECEDING SENTENCE, ERIS DOES NOT WARRANT OR REPRESENT THAT (A) ANY COMPONENT WILL BE AVAILABLE AT ANY TIME FOR USE, (B) ANY ACCESS TO, OR USE OF, A COMPONENT WILL BE UNINTERRUPTED, (C) THERE ARE NO ERRORS IN ANY COMPONENT, AND TO THE EXTENT ANY SUCH ERRORS EXIST, THEY WILL BE CORRECTED, (D) ANY COMPONENT IS FREE OF MALWARE, VIRUSES OR OTHER HARMFUL CODE, OR (E) ANY COMPONENT IS ACCURATE, COMPLETE OR SUFFICIENT FOR ANY PURPOSE.</b>
                </p>
                <p>
                    9. &nbsp;<u><b>Third-Party Sites</b></u>
                    <br>
                    A Component may from time to time be linked to websites that are not offered by ERIS (a “<b><u>Third-Party Site</u></b>”).  No link from a Component to a Third-Party Site, or from a Third-Party Site to a Component, is an endorsement, sponsorship or recommendation by ERIS of such Third-Party Site, and the link is provided only for the convenience of Customer.  ERIS is not responsible, and will have no liability, for (a) any content contained on, or any policies or practices of, any Third-Party Site, (b) any link between a Component and a Third-Party Site, or (c) otherwise with respect to any Third-Party Site. 
                </p>
                <p>
                    10. &nbsp;<u><b>Information Protection</b></u>
                    <br>
                    ERIS will use commercially reasonable efforts to protect from unauthorized disclosure to, or modification or use by, third parties any content or other information provided to ERIS by Customer through the Application.  However, ERIS does not guaranty that any such content or other information is secure from unauthorized disclosure to, or modification or use by, third parties (a “<b><u>Breach</u></b>”), and ERIS will not be responsible for, or liable to, Customer for any Breach so long as ERIS uses commercially reasonable efforts to (a) protect such content or other information from such Breach and (b) mitigate any adverse consequences of such Breach, subject at all times to Section 11.  For the sake of clarity, ERIS may disclose any such content or other information as required by any applicable law (including, but not limited to, any such disclosure in response to a subpoena or court order).   
                </p>
                <p>
                    11. &nbsp;<u><b>Liability Limitation</b></u>
                    <br>
                    <b>ERIS WILL NOT BE LIABLE TO CUSTOMER IN CONNECTION WITH THESE TERMS OF USE, ANY COMPONENT OR OTHERWISE, WHETHER SUCH LIABILITY IS BASED ON BREACH OF CONTRACT, COMMISSION OF A TORT OR OTHER THEORY OF LIABILITY, EVEN IF THE POSSIBILITY OF SUCH DAMAGES COULD HAVE BEEN FORESEEN BY ERIS, FOR (A) ANY CONSEQUENTIAL, INCIDENTAL, INDIRECT, PUNITIVE, SPECIAL OR OTHER SIMILAR DAMAGES INCURRED BY CUSTOMER OR (B) ANY DIRECT DAMAGES INCURRED BY CUSTOMER IN EXCESS OF THE AMOUNT PAID BY CUSTOMER FOR ANY REPORT THAT IS THE SUBJECT OF, OR RELATED TO, SUCH DIRECT DAMAGES.</b>
                </p>
                <p>
                    12. &nbsp;<u><b>Indemnification</b></u>
                    <br>
                    Customer shall indemnify, defend and hold harmless ERIS from and against all costs, damages, expenses, fines, indebtedness, liabilities, losses, penalties and other payments incurred by ERIS (including, but not limited to, fees and disbursements of counsel to ERIS) in connection with (a) Customer’s use of any Component, (b) Customer’s failure to perform any obligation pursuant to these Terms of Use, (c) ERIS’s taking any action permitted by these Terms of Use, and (d) any other matter relating to a Component, except to the extent such costs, damages, expenses, fines, indebtedness, liabilities, losses, penalties or other payments are incurred by ERIS solely due to the gross negligence or intentional misconduct of ERIS.
                </p>
                <p>
                    13. &nbsp;<u><b>Notice</b></u>
                    <br>
                    Customer must send notices to ERIS by regular mail, postage prepaid, as follows:
                </p>
                <p>
                    If Customer is located in the United States: 
                </p>
                <p>
                    ERIS Information Inc. <br>
                    P.O. Box 930 <br>
                    Buffalo, New York 14222 <br>
                </p>
                <p>
                    If Customer is located in Canada: 
                </p>
                <p>
                    ERIS Information L.P. <br>
                    38 Lesmill, Unit 2 <br>
                    Toronto, Ontario M3B 2T5 <br>
                </p>
                <p>
                    Any such notice will be effective upon actual receipt by ERIS.
				</p>
				<p>
                    ERIS may send notices to Customer through e-mail, regular mail or a general posting on the Site.  Any such notice will be effective (a) immediately upon ERIS’s sending such notice to the address it has in its records for Customer in the case of e-mail, (b) five days after ERIS mails such notice to the address it has in its records for Customer in the case of regular mail, and (c) immediately upon Customer’s entering the Site after such notice is posted on the Site. 
                </p>
                <p>
                    14. &nbsp;<u><b>Disputes</b></u>
                    <br>
                    These Terms of Use shall be governed by, and interpreted and enforced in accordance with, the internal law of the state of New York, without regard to its principles of conflict of laws.  Any dispute relating to these Terms of Use, any Component or any additional terms and conditions provided on the Site may only be submitted to a court having subject matter jurisdiction over such dispute and located in Erie County, New York if Customer is located in the United States or in York County, Ontario if Customer is located in Canada.  Customer consents to such court’s being, and waives any objection (including, but not limited to, any objection based on inconvenience) to such court’s not being, a proper venue for such dispute.
                </p>
                <p>
                    15. &nbsp;<u><b>Severability</b></u>
                    <br>
                    Whenever possible, each provision of these Terms of Use shall be interpreted in such a manner as to be effective and valid under applicable law.  If, however, any such provision shall be prohibited by or invalid under such law, it shall be deemed modified to conform to the minimum requirements of such law, or if for any reason it is not deemed so modified, it shall be prohibited or invalid only to the extent of such prohibition or invalidity without the remainder of such provision, or any other provision of these terms and conditions being prohibited or invalid. 
                </p>
                <p>
                    16. &nbsp;<u><b>Amendments</b></u>
                    <br>
                    ERIS may amend these Terms of Use at any time.  Customer will be bound by such amendment (a) immediately upon an e-mail message with respect to such amendment being sent to the address ERIS has in its records for Customer, (b) five days after mailing with respect to such amendment being sent by regular mail to the address ERIS has in its records for Customer, (c) immediately upon Customer’s entering the Site after a general notification of such amendment has been posted on the Site, or (d) immediately upon Customer’s affirmatively accepting these Terms of Use, as so amended, when using the Application or the Site, in each case regardless of whether or not Customer has actually read or assented to such amendment. 
                </p>
                <p>
                    17. &nbsp;<u><b>Miscellaneous</b></u>
                    <br>
                    These Terms of Use (a) inure to the benefit of, and are binding upon, Customer and ERIS and each of Customer’s and ERIS’s successors and assignees, except that Customer may not assign any of Customer’s rights or obligations under these Terms of Use without first obtaining the written consent of ERIS, and (b) constitute the entire agreement between Customer and ERIS with respect to their subject matter, and supersede all prior oral and written proposals, representations, understandings and agreements. 
                </p>                    
                <p style="text-align: center;">
                    <b>These Terms of Use and all Content (not including any Content licensed by ERIS from third parties or in the public domain) copyright {{year()}} ERIS Information Inc. or ERIS Information L.P.</b>
                </p>
                <p style="text-align: center;">
                    <b>All rights reserved.</b>
                </p>
            </div>
		</div>
		<div class="modal-footer" style="background-color: #323232; color: rgb(222, 222, 222); border: 0px">
			<input type="checkbox" id="chk-disclaimeraccept" [(checked)]="disclaimerAcceptedFlag" (change)="updateDisclaimer();">
			<label for="disclaimerAccept">I accept the terms of use.</label>
			<button (click)="disclaimerModalReference.close();" style="float:right; background-color: rgb(195,212,47)"
					class="btn btn-default" [disabled]="!disclaimerAcceptedReal" id="btn-disclaimeraccept">Proceed >></button>
		</div>
	</ng-template>
	<div class="row bar">
		<div style="padding: 0;  margin: 0;overflow:hidden; height:100%; width:20%">
			<a href="https://Scriva.com/" target="_blank">
				<!--img src="assets/images/logo.png" style="margin:0px; padding:0px; height:90%; width:100%"-->
				<img src="assets/images/Scriva_ALLTEXT_Logo_onDarkBG_RGB_small.png" style="margin:0px; padding:0px; height:90%; width:100%">
				<!-- <img src="assets/images/Scriva_byERIS_ALLTEXT_Logo_onDarkBG_RGB_small.png" style="margin:0px; padding:0px; height:90%; width:100%"> -->
				<!-- <img src="assets/images/Scriva_byERIS_Logo_onBlue.png" style="margin:0px; padding:0px; height:90%; width:100%"> -->
				<!--img src="assets/images/Scriva_byERIS_Logo_onWhite.png" style="margin:0px; padding:0px; height:90%; width:100%"-->
				<!--img src="assets/images/Scriva_Logo_onWhite.png" style="margin:0px; padding:0px; height:90%; width:100%"-->
				<!--img src="assets/images/Scrivia_byERIS_Logo_BW.jpg" style="margin:0px; padding:0px; height:90%; width:100%"-->

			</a>
		</div>
		<div style="margin:0px; padding:0px; width:80%;">
			<table style="width:100%;">
				<tr>
					<td style="height:60px; vertical-align:top; width:50vw">
						<div class="row" style="width:100%; margin:0; padding:0;" [innerHTML]="infoContent">
							
						</div>
						<div class="row" style="width:100%; margin:0; padding:0; color:white; display: none;">
							<ng-container *ngIf='user?.REPORT_ID' >
									<div style="width: 35%">
										<span style="margin-left: 10px;" [title]="user?.PROJECT_NUMBER">
										<strong>Project Number: </strong>
										<!--{{user?.PROJECT_NUMBER}}</span>-->
										{{user?.PROJECT_NUMBER.substring(0, 20)}}<span *ngIf="user?.PROJECT_NUMBER.length>20"> . . . </span></span>
										<i class="fas fa-chevron-down ml-1" style="color:#c2d63e" (click)="op.toggle($event)"></i><br>
										<p-overlayPanel #op [appendTo]="'body'" [dismissable]="true" [style]="{width: '300px'}">
                                                <ng-template pTemplate>
                                                    <div style="width: 280px; margin: 4px 10px; padding-right:0; color:#C2D63F;font-size:.8em"> 
														<label style="font-weight:bold">Reports in Project: </label><br>
														<ng-container *ngFor="let rpt of rpts">
															<a [href]="'report/'+rpt.PROJECT_ID+'/'+rpt.REPORT_ID" target='_blank' [ngClass]="{'disabled':rpt.REPORT_ID==user.REPORT_ID}">{{rpt.REPORT_TITLE}}</a><br>
														</ng-container>														
                                                    </div>
                                                </ng-template>
                                            </p-overlayPanel>
										<span style="margin-left: 10px;" [title]="user?.FULL_ADDRESS">
										<strong>Property Address: </strong> 
										<!--{{user?.ADDRESS_LINE1}}<span *ngIf="user?.ADDRESS_LINE1">,</span>
										{{user?.CITY}}<span *ngIf="user?.CITY">,</span> {{user?.PROVSTATE}}<span *ngIf="user?.PROVSTATE">,</span> {{user?.POSTALZIP}}<span *ngIf="user?.POSTALZIP">,</span>
										{{user?.COUNTRY}}-->
										{{user?.FULL_ADDRESS.substring(0, 20)}}<span *ngIf="user?.FULL_ADDRESS.length>20"> . . . </span>
										
										</span>
									</div>
									<div style="width: 30%">
										<span [title]="user?.REPORT_TITLE">
										<strong>Report Type: </strong>
										{{user?.REPORT_TITLE.substring(0, 20)}}<span *ngIf="user?.REPORT_TITLE.length>20"> . . . </span></span>
										
										<br>
										<span [title]="user?.PROPERTY_NAME">
										<strong>Property Name: </strong>
										{{user?.PROPERTY_NAME.substring(0, 20)}}<span *ngIf="user?.PROPERTY_NAME.length>20"> . . . </span></span>
										
									
									</div>
									<div style="width: 25%">
										<span [title]="user?.TEMPLATE[0]?.TEMPLATE_TITLE">
											<strong>Template Name: </strong>
											<a [href]="'template/'+user?.TEMPLATE[0]?.TEMPLATE_ID" target='_blank' >
											{{user?.TEMPLATE[0]?.TEMPLATE_TITLE.substring(0, 15)}}<span *ngIf="user?.TEMPLATE[0]?.TEMPLATE_TITLE.length>15"> . . . </span>
										</a>
										</span><br>										
										<span [title]="user?.TEMPLATE[0]?.CATEGORY_NAME">
											<strong>Template Category: </strong>
											{{user?.TEMPLATE[0]?.CATEGORY_NAME.substring(0, 15)}}<span *ngIf="user?.TEMPLATE[0]?.CATEGORY_NAME.length>15"> . . . </span>
										
										</span>
									
									</div>
									<div style="width: 10%">
										<span>
										<strong>Status: </strong> {{user?.STATUS}}</span>
											<i class="btn-outline-dark btn-small fas fa-chevron-down p-0 ml-1" style="color:#c2d63e" (click)="op1.toggle($event)"></i>
											<p-overlayPanel #op1 [appendTo]="'body'" [dismissable]="true" [style]="{width: '150px'}">
                                                <ng-template pTemplate>
                                                    <div style="width: 140px; margin: 4px 5px; padding-right:0; color:#C2D63F;font-size:.8em"> 
														<ng-container *ngFor="let item of statusList; let i = index">
															<a [ngClass]="{'disabled':item.STATUS==user.STATUS}" id="lnk-status{{i}}" (click)="op1.hide(); user.STATUS=item.STATUS; changeStatus(item.STATUS)">{{item.STATUS}}</a><br>
														</ng-container>												
                                                    </div>
                                                </ng-template>
                                            </p-overlayPanel>
											<br>
											<!--<a *ngIf="user?.REPORT_URL&&user.REPORT_URL.length>0" href="javascript:void(0)" (click)="getRUrl()"><i class="fas fa-file-pdf"></i></a>-->
											<a href="javascript:void(0)" (click)="getRUrl()" id="lnk-geturl"><i class="fas fa-file-pdf"></i></a>
									</div>
									
									
									
									
									
								</ng-container>
								<ng-container *ngIf='user?.TEMPLATE_TYPE'>
									<div style="width: 50%">
									<span style="margin-left: 20px;"><strong>Template Name: </strong>
										{{user?.TEMPLATE_TITLE}}
										<a class="ml-1"  id="lnk-edittemplatetitle"  style="cursor:pointer;" 	(click)="op2.toggle($event);"
													
										title="Edit Template title"><i class="erisGreen fas fa-pen"></i></a>
			
										<p-overlayPanel #op2 [appendTo]="'body'">
										  <ng-template pTemplate> 
											<input class="rptInfo" style="width:300px;" type="text" [(ngModel)]="user.TEMPLATE_TITLE">
																	  <button (click)="updateTemplateTitle(user); op2.hide()"
																		class="btn m-0 uploadBtn" id="btn-templatesave">Save</button>
											</ng-template>
											</p-overlayPanel>
									</span>
									
									<br>
									<span style="margin-left: 20px;"><strong>Template Category: </strong>
										{{user?.TEMPLATE_TYPE[0].CATEGORY_NAME}}</span>
									</div>
									<div style="width: 40%">
									<span><strong>Template Identifier: </strong>
										{{user?.TEMPLATE_TYPE[0].SUBCATEGORY_NAME}}</span>
									</div>
								</ng-container>
								<ng-container *ngIf='user?.COVERPAGE_ID'>
									<span style="margin-left: 120px;margin-top:10px">
									<strong>Cover Page Name: </strong>
										{{user?.COVERPAGE_TITLE}}
										<a class="ml-1" id="lnk-editcoveragetitle"   style="cursor:pointer; float:right" 	(click)="op3.toggle($event);"
													
										title="Edit Coverage title"><i class="erisGreen fas fa-pen"></i></a>
			
										<p-overlayPanel #op3 [appendTo]="'body'">
										  <ng-template pTemplate> 
											<input class="rptInfo" style="width:300px" type="text" [(ngModel)]="user.COVERPAGE_TITLE">
																	  <button (click)="updateCoverpageTitle(user); op3.hide()"
																		class="btn m-0 uploadBtn" id="btn-coverpagesave">Save</button>
											</ng-template>
											</p-overlayPanel>
									</span>								
								</ng-container>
								<ng-container *ngIf='user?.HEADERFOOTER_ID'>
									<span style="margin-left: 120px;margin-top:10px">
									<strong>
											<ng-container *ngIf="user?.TYPE=='HEADER'">
												Header Name: 
											</ng-container>
											<ng-container *ngIf="user?.TYPE=='FOOTER'">
												Footer Name:
											</ng-container>
											</strong>
										{{user?.HF_TITLE}}</span>								
								</ng-container>
							
						</div>
					</td>

					<td style="width:50vw">
						<div class="row">
							<!-- <div class="col-md-6">

							</div> -->
							<div class="col-md-12">
								<button *ngIf="loginInfo!='USER'" id="userNameButton" class="ml-3 btn btn-secondary" 
										style="float:right; margin-right: 10px; font-size: 16px; border: 0px; background-color: rgb(28 36 51);"
										(click)="toLogo()">
									{{loginInfo}}
								</button>

								<button class="ml-3 btn btn-secondary" id="GetSupportHereButton" 
										style="float:right; background-color: rgb(195,212,47); color: black; font-size: 16px; border: 0px"
										(click)='openSupportPage();'>
										Get Support Here
								</button>
								<button class="ml-3 btn btn-secondary" id="GetSupportHereButton" 
										style="float:right; background-color: rgb(28 36 51); color: white; font-size: 16px; border: 0px"> 
									<a id="lnk-newsalert" style="color: white" [href]="'https://www.erisinfo.com/ca/'" target="_blank">
										News Alert <span style="margin-left: 5px;"> <i class="fas fa-external-link-alt"></i> </span> 
									</a>
								</button>

								<ul class="list-unstyled text-xl-right">
									<!--<li  data-toggle="modal" data-target="#myModal">
				<button id="sign-in" class="btn btn-primary">{{loginInfo}}</button>
			</li>
			<li class="topText" >
				<div class="dropdown">
					<a id="user-info" class="btn btn-primary dropdown-toggle" type="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						userInfo
					</a>
					<div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton" >
						<a class="dropdown-item" style="font-size:0.8em;" href="#">Log Out</a>
					</div>
				</div>
			</li>-->
									<!--<li *ngIf="loginInfo!='USER'" class="topText" >
				<div class="dropdown">
					<a id="user-info" class="btn dropdown-toggle" style="background:rgb(195,212,47); color: white "type="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
						{{loginInfo}}
					</a>
					<div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton" >
						<a class="dropdown-item" style="font-size:0.8em;" href="javascript:void(0)" (click)="logOut()">Log Out</a>
					</div>
				</div>
			</li>-->
								</ul>
							</div>
						</div>

					</td>
				</tr>
			</table>
		</div>
	</div>
</header>
<div id="email-us">
	<a href="mailto:scriva_support@erisinfo.com" title="Email Us" class="m-1" style="cursor: pointer;">
		<i class="fas fa-envelope"></i>
	</a>
</div>